// extracted by mini-css-extract-plugin
export var formContainer = "_gx-0";
export var message = "_gx-1";